<template>
    <section id="cta-content-home">

        <div class="container title">
            <h2 class="gtitle mb-3 fw-bold">Regardless of coverage, eligible commercially insured patients <br class="d-none d-lg-block" /> can access JORNAY PM</h2>
            <p>Learn more about <a href="/savings">patient savings</a>, or if you need assistance finding a particular
                dosage strength, call our
                Pharmacy Locator service at 1-877-938-4766, Monday-Friday 8 <span class="ampm-text">AM</span> to 9 <span class="ampm-text">PM</span>
                ET.
            </p>
        </div>

        <CTABanner :onlyBanner="true" :bannerData="{bannerText: 'See Efficacy', href:'/adhd-medication-efficacy'}"/>

    </section>
</template>



<script>

import CTABanner from "../CTABanner.vue";

export default {
    components: {
        CTABanner
    },
    data() {
        return {
        }
    }


}
</script>